import { Injectable } from '@angular/core';
import { Product } from '@df/catalog/product/product';
import { DfEventData } from '@df/core/service/df-event';
import {
    PRODUCT_CLOSE_PREVIEW_EVENT_NAME,
    PRODUCT_OPEN_PREVIEW_EVENT_NAME,
    PRODUCT_PREPARE_PREVIEW_EVENT_NAME,
    PRODUCT_WISHLIST_ADD_EVENT_NAME,
    PRODUCT_WISHLIST_OPEN_PREVIEW_EVENT_NAME,
    PRODUCT_WISHLIST_PREPARE_PREVIEW_EVENT_NAME,
    ProductEventData
} from './product.abstract';

@Injectable({
    providedIn: 'root'
})
export class ProductService {
    canTriggerEvent(event: DfEventData, model: Product, index?: number): boolean {
        const data = event.data as ProductEventData;
        const listPosition = data?.index !== undefined ? data.index : undefined;

        if (listPosition !== undefined && listPosition !== index) {
            return false;
        }

        if (
            [
                PRODUCT_CLOSE_PREVIEW_EVENT_NAME,
                PRODUCT_OPEN_PREVIEW_EVENT_NAME,
                PRODUCT_PREPARE_PREVIEW_EVENT_NAME,
                PRODUCT_WISHLIST_ADD_EVENT_NAME,
                PRODUCT_WISHLIST_OPEN_PREVIEW_EVENT_NAME,
                PRODUCT_WISHLIST_PREPARE_PREVIEW_EVENT_NAME
            ].includes(event.id) &&
            data.product.id === model.id
        ) {
            return true;
        }

        return false;
    }
}
